export const LATVIAN_STATE = {
  lang: "lv",
  messages: {
    "app.gameselection.title": "Pulmikas spēle",
    "app.gameselection.gameid": "Spēles ID",
    "app.gameselection.instruction": "Ievadiet ID, kas redzams kopīgotajā ekrānā",
    "app.login.title": "Pieteikties",
    "app.login.logout": "Izrakstīties",
    "app.login.wrongcredentials": "Nepareizs ID vai parole!",
    "app.login.password": "parole",
    "app.login.username": "ID",
    "app.exitgame": "Iziet no spēles",
    "app.hourglass": "Smilšu pulkstenis",
    "app.arrowleft": "Bultiņa pa kreisi",
    "app.arrowundo": "Atsaukt",
    "app.greystar": "Pelēkā zvaigzne",
    "app.goldstar": "Zelta zvaigzne",
    "app.thumbup": "Īkšķis uz augšu",
    "app.thumbdown": "Nepatīk",
    "app.select": "Atlasīt",
    "app.speechbubbles": "Runas burbulis",
    "app.accordioniconplus": "Rādīt",
    "app.typeicon": "Rakstīt",
    "player.groupselection.title": "Izvēlieties komandu",
    "player.drawavatar.title": "Zīmēt",
    "player.drawavatar.instruction": "Uzzīmējiet sev avatāru",
    "player.avatar": "Avatars",
    "player.namegroup.title": "Komandas nosaukums",
    "player.namegroup.instruction": "Kopā piešķiriet jūsu komandai nosaukumu",
    "player.factquestion.answer.title": "Ievadiet savu atbildi",
    "facilitator.factquestion.answer": "Pagaidiet, līdz visi spēlētāji ir atbildējuši.",
    "facilitator.factquestion.result": "Spēlētāji meklē pareizo atbildi.",
    "player.openquestion.answerscreen.placeholder": "Maksimālais garums: 100 rakstzīmes",
    "screen.openquestion.answerscreen.choosebest": "Izvēlieties piemērotāko atbildi no šādiem atbilžu variantiem",
    "player.openquestion.answerscreen.voteinstruction": "Izvēlieties piemērotāko atbildi",
    "facilitator.openquestion.answerscreen.answer": "Nogaidiet, līdz visi spēlētāji pārrunās pavedienus un ievadīs savas atbildes.",
    "player.ratescreen.title": "Paldies par piedalīšanos spēlē",
    "player.ratescreen.instruction": "Kā jūs novērtētu šo spēli?",
    "facilitator.gameexit.confirmation": "Vai esat pārliecināts, ka vēlaties beigt?",
    "facilitator.logout.confirmation": "Vai esat pārliecināts, ka vēlaties izrakstīties?",
    "facilitator.gameselect.title": "Izvēlieties spēli",
    "facilitator.groupsize.title": "Cik komandas?",
    "facilitator.groupsize.instruction": "Ieteiktas komandas lielums ir 3–4 spēlētāji. Maksimālais komandu skaits ir 6",
    "facilitator.groupmoderation.title": "Moderācija",
    "facilitator.groupmoderation.instruction": "Komandas ir gatavas",
    "facilitator.groupmoderation.namereset": "Atiestatīt nosaukumu",
    "facilitator.groupmoderation.info": "Spēlētāji pievienojas spēlei. Sāciet spēli, kad visi ir pievienojušies.",
    "facilitator.waitscreen.read": "Spēlētāji ir gatavi. Jūs varat arī tekstu nolasīt priekšā.",
    "facilitator.waitscreen.discuss": "Spēlētāji apspriež jautājumu.",
    "facilitator.waitscreen.multiquestion.discuss": "Spēlētāji diskutē. Kad virzīsieties tālāk, viņi saņems atbilžu variantus un pavedienus.",
    "facilitator.waitscreen.openquestion.discuss": "Spēlētāji diskutē. Kad jūs virzīsieties tālāk, viņi saņems atbilžu lauku un pavedienus.",
    "facilitator.waitscreen.debatewheel": "Spēlētājs, kas paskaidros atbildi, ir izvēlēts pēc nejaušības principa.",
    "facilitator.waitscreen.voteresults": "Spēlētāji aplūko balsošanas rezultātus.",
    "facilitator.waitscreen.debateresults": "Spēlētāji aplūko rezultātus.",
    "facilitator.setupbigscreen.title": "Kopīgots ekrāns",
    "facilitator.setupbigscreen.subtitle": "Atveriet spēles skatu, pārejot uz to:",
    "facilitator.setupbigscreen.description": "pulmikas.net/lv/screen",
    "facilitator.setupbigscreen.screencode": "Spēles ID",
    "facilitator.setupbigscreen.instructiontitle": "Palīdzība:",
    "facilitator.setupbigscreen.instructioncontent-1": "Kopīgotajam spēles ekrānam ir jābūt redzamam visiem spēlētājiem.",
    "facilitator.setupbigscreen.instructioncontent-2": "Ja varat kopīgot šīs ierīces ekrānu, atveriet pārlūkprogrammas logu un dodieties uz adresi: pulmikas.net/lv/screen.",
    "facilitator.setupbigscreen.instructioncontent-3": "Ja izmantojat citu ierīci ekrāna kopīgošanai, dodieties uz adresi: pulmikas.net/lv/screen, izmantojot šo ierīci un ievadiet ID logā, kas atvērsies.",
    "facilitator.setupbigscreen.url": "lv/screen",
    "facilitator.factquestion.answermoderation.answers": "atbildes",
    "facilitator.multiquestion.answerreset": "Noņemt atbildi",
    "facilitator.multiquestion.answer": "Atbilde:",
    "facilitator.multiquestion.answerscreen.waitingforanswer": "Gaida atbildi",
    "facilitator.multiquestion.answerscreen.ready": "Gatavs",
    "facilitator.multiquestion.debatemoderation.title": "Paskaidrojums",
    "facilitator.multiquestion.debatemoderation.speaking": "Komanda, kas pašlaik izsakās:",
    "facilitator.multiquestion.debatemoderation.accepted": "Apstiprināts",
    "facilitator.multiquestion.debatemoderation.declined": "Noraidīts",
    "facilitator.multiquestion.debatemoderation.instruction": "Noklausieties komandas paskaidrojumu",
    "facilitator.multiquestion.answer.answer": "Pagaidiet, kamēr spēlētāji apspriež pavedienus un izvēlas savu atbildi.",
    "facilitator.multiquestion.answer.result": "Spēlētāji aplūko rezultātus.",
    "screen.welcomescreen.title": "Sveicināti!",
    "screen.welcomescreen.instruction": "Doties uz pulmikas.net",
    "screen.factquestion.answerScreen.title": "Pareiza atbilde",
    "screen.multiquestion.debatescreen.instruction": "Lūdzu paskaidrojiet, kāpēc domājat, ka izvēlētais atbilžu variants ir vispiemērotākais",
    "screen.openquestion.debatescreen.instruction": "Lūdzu, paskaidrojiet savas komandas atbildi",
    "facilitator.openquestion.vote": "Spēlētāji balso par labāko atbildi.",
    "screen.debatewheel.title": "Kurš izskaidros?",
    "thanksforplaying": "Paldies par piedalīšanos spēlē!",
    "startbutton": "Izvēlieties spēli",
    "startgamebutton": "Sāciet spēli",
    "startnewgame": "Sāciet jaunu spēli",
    "logout": "Izrakstīties",
    "readybutton": "Gatavs",
    "nextbutton": "Nākamais",
    "group": "Komanda",
    "wait": "Gaidiet",
    "yes": "Jā",
    "no": "Nē",
    "hint": "Pavediens",
    "discuss": "Apspriest",
    "listen": "Klausīties",
    "debate": "Izskaidrot",
    "forward": "Uz priekšu",
    "send": "Sūtīt",
    "press1second": "Apturēt uz divām sekundēm",
    "waitMoment": "Nedaudz pagaidiet",
    "errorMessage": "Kaut kas nogāja greizi, lūdzu, mēģiniet pieteikties vēlreiz"
  }
}